import axios from "axios";
import baseURL from "../configs/api";

export const post_Payment = async (data: any, userId: number, tenantId: string) => {
    const response = await axios({
        url: `${baseURL}payment?userId=${userId}`,
        method: "POST",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    });
    return response.data;
}

export const post_PaymentFromPaymentRequest = async (data: any, userId: number) => {
    const response = await axios({
        url: `${baseURL}payment/MakePaymentFromPaymentRequest`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        withCredentials: true,
        data: data,
        params: {
            userId
        }
    });
    return response.data;
}

export const post_PaymentWitCreditCard = async (data: any, userId: number, tenantId: string) => {
    const response = await axios({
        url: `${baseURL}payment/makePaymentWithCreditCard?userId=${userId}`,
        method: "POST",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    });
    return response.data;
}

export const post_PaymentForValidateOutstandingBalance = async (data: any, id: number, userId: number, tenantId: string) => {
    const response = await axios({
        url: `${baseURL}payment/paymentForValidateOutstandingBalance`,
        method: "POST",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data,
        params: {
            id,
            userId
        }
    });
    return response.data;
}

export const getReservationPaymentsByReservationId = (reservationId: number, tenantId: string) => {
    return getFetch(`payment/PaymentsByReservation/${reservationId}`, tenantId);
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        params: params
    }).then(response => response.data);
}